import FormField from '../components/FormField';
// eslint-disable-next-line import/no-cycle
import ArrayField from '../components/ArrayField';
// eslint-disable-next-line import/no-cycle
import FormGroup from '../components/FormGroup';
import isObjectLike from './isObjectLike';

export default function getFieldComponent(
  adapter,
  {
    'ui:control': uiControl,
    'ui:props': { control: uiPropsControl } = {},
    options,
    type,
    ...restField
  }
) {
  if (type === 'object' || isObjectLike(restField)) {
    return FormGroup;
  }

  const { key: FieldComponentKey } =
    adapter.findComponent(uiControl ?? uiPropsControl ?? type, Array.isArray(options)) ?? {};

  if (FieldComponentKey === 'ArrayField') {
    return ArrayField;
  }

  return FormField;
}
